import Vue from 'vue'
import Router from 'vue-router'

// Containers
import Full from '@/containers/Full'

// Views
import Dashboard from '@/views/Dashboard'
import Targets from '@/views/targets/targets'
import Accounts from '@/views/Accounts/Accounts'
import Visits from '@/views/Visits/Visits'
import Equipment from '@/views/equipment/Equipment'
import Sra from '@/views/sra/Sra'
import Promotions from '@/views/promotions/Promotions'
import Stocks from '@/views/stocks/Stocks'

// pages
import Page404 from '@/views/pages/Page404'
import Page500 from '@/views/pages/Page500'
import Login from '@/views/pages/Login'
import Forgot from '@/views/pages/Forgot'
import ResetPassword from '@/views/pages/ResetPassword'

import MissingRouter from '@/views/tables/missingRouter.js'

import UsersGrid from '@/views/users/UsersGrid'
import UsersEdit from '@/views/users/UsersEdit'
import Profile from '@/views/users/Profile'
// roles
import RolesGrid from '@/views/roles/grid'
import RolesEdit from '@/views/roles/edit'
//
//
import Statistics from '@/views/statistics/Statistics'

// import GenericGrid from '@/views/generic/GenericGrid'
// import GenericEdit from '@/views/generic/GenericEdit'

Vue.use(Router)

var usersRoutes = {
  path: '/users',
  redirect: '/users/index',
  name: 'users',
  meta: {
    auth: {
      redirect: {
        name: 'users.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Utilizadores'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'users.index',
    component: UsersGrid,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'create',
    name: 'users.create',
    component: UsersEdit,
    meta: {
      auth: true,
      label: 'Criar'
    }
  }, {
    path: 'edit/:id',
    name: 'users.edit',
    component: UsersEdit,
    meta: {
      auth: true,
      label: 'Editar'
    }
  }]
}

var rolesRoutes = {
  path: '/roles',
  redirect: '/roles/index',
  name: 'roles',
  meta: {
    auth: {
      redirect: {
        name: 'roles.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Utilizadores'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'roles.index',
    component: RolesGrid,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'create',
    name: 'roles.create',
    component: RolesEdit,
    meta: {
      auth: true,
      label: 'Criar'
    }
  }, {
    path: 'edit/:id',
    name: 'roles.edit',
    component: RolesEdit,
    meta: {
      auth: true,
      label: 'Editar'
    }
  }]
}

export default new Router({
  mode: 'hash',
  linkActiveClass: 'active',
  scrollBehavior: () => ({
    y: 0
  }),
  routes: [{
    path: '/',
    redirect: '/dashboard',
    name: 'Home',
    component: Full,
    children: [{
      path: 'dashboard',
      name: 'dashboard',
      component: Dashboard,
      meta: {
        auth: true
      }
    }, {
      path: 'targets',
      name: 'targets',
      component: Targets,
      meta: {
        auth: true
      }
    }, {
      path: 'accounts',
      name: 'accounts',
      component: Accounts,
      meta: {
        auth: true
      }
    }, {
      path: 'visits',
      name: 'visits',
      component: Visits,
      meta: {
        auth: true
      }
    }, {
      path: 'stocks',
      name: 'stocks',
      component: Stocks,
      meta: {
        auth: true
      }
    }, {
      path: 'equipment',
      name: 'equipment',
      component: Equipment,
      meta: {
        auth: true
      }
    }, {
      path: 'promotions',
      name: 'promotions',
      component: Promotions,
      meta: {
        auth: true
      }
    }, {
      path: 'sra',
      name: 'sra',
      component: Sra,
      meta: {
        auth: true
      }
    }, {
      path: 'profile',
      name: 'profile',
      component: Profile,
      meta: {
        auth: true
      }
    }, {
      path: '/statistics',
      redirect: '/statistics/index',
      name: 'statistics',
      meta: {
        auth: true,
        label: 'DIM'
      },
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [{
        path: ':id',
        name: 'statistics.index',
        component: Statistics,
        meta: {
          auth: true,
          label: 'Lista'
        }
      }]
    }, MissingRouter, usersRoutes, rolesRoutes]
  }, {
    path: '/login',
    name: 'login',
    component: Login
  }, {
    path: '/forgot-password',
    name: 'forgot-password',
    component: Forgot
  }, {
    path: '/reset-password/:token',
    name: 'reset-password',
    component: ResetPassword
  }, {
    path: '/404',
    name: '404 Not Found',
    component: Page404
  }, {
    path: '/500',
    name: '500 Internal error',
    component: Page500
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js